<template>
  <section class="hero is-flex main">
    <div class="bg-img">
      <div class="img2 icon"><img src="../assets/images/book.png" alt="" /></div>
      <div class="img3 icon"><img src="../assets/images/rocket.png" alt="" /></div>
      <div class="img4 icon"><img src="../assets/images/cloud3.png" alt="" /></div>
      <div class="img5 icon"><img src="../assets/images/award.png" alt="" /></div>
      <div class="img6 icon"><img src="../assets/images/apple.png" alt="" /></div>
    </div>

    <div class="title">Dashboard</div>
    <p class="school-subtitle" v-if="getUserSchoolName">{{ getUserSchoolName }}</p>

    <div class="school-dashboard">
      <div class="school-grid">
        <div
          v-for="(card, i) in cards"
          :key="i"
          class="school-card"
          :style="`--card-color: ${card.color}`"
          @click="goTo(card.route)"
          role="button"
          tabindex="0"
          @keyup.enter="goTo(card.route)"
        >
          <div class="school-card-icon">
            <img :src="card.img" :alt="card.name" />
          </div>
          <div class="school-card-body">
            <div class="school-card-title">{{ card.name }}</div>
            <div class="school-card-desc">{{ card.description }}</div>
          </div>
          <div class="school-card-arrow" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SchoolHome",
  computed: {
    ...mapGetters(["getUserType", "getUserSchoolName"]),
    cards() {
      const all = [
        {
          name: "Manage Accounts",
          description: "Add and manage teachers and students",
          img: require("../assets/images/user.svg"),
          route: "manage-account",
          color: "rgb(137 25 231)",
          roles: ["SA"]
        },
        {
          name: "Manage Classrooms",
          description: "Create classrooms and assign people",
          img: require("../assets/images/user.svg"),
          route: "classrooms",
          color: "rgb(49 200 255)",
          roles: ["SA", "ST"]
        }
      ];
      return all.filter(c => !c.roles || c.roles.includes(this.getUserType));
    }
  },
  methods: {
    goTo(name) {
      if (name) this.$router.push({ name });
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}
.bg-img .icon {
  max-width: 7vw;
  height: auto;
  opacity: 0.85;
}
.bg-img .img2 { top: 50%; right: 13.5%; }
.bg-img .img3 { top: 66.33%; left: 21.7%; }
.bg-img .img4 { top: 36.33%; right: 7.625%; }
.bg-img .img5 { top: 54.44%; left: 7.4375%; }
.bg-img .img6 { top: 51.67%; left: 18.6%; }

.main {
  align-items: center;
  margin: 0;
  position: relative;
  gap: 0.5rem;
  padding: clamp(1rem, 2.5vw, 2rem) clamp(0.75rem, 2vw, 1.5rem) clamp(2rem, 5vw, 3.5rem);
  min-height: auto;
}

.main::after {
  content: '';
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40vh;
  max-height: 420px;
  background-image: url(../assets/images/cloud2.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom center;
  pointer-events: none;
  z-index: 1;
}

.title {
  position: relative;
  z-index: 2;
  font-size: clamp(1.75rem, 3.2vw, 2.6rem) !important;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  margin: 0 !important;
  text-align: center;
  background: linear-gradient(135deg, #8919e7 0%, #4361ee 60%, #31c8ff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  line-height: 1.1;
}

.school-subtitle {
  position: relative;
  z-index: 2;
  font-size: 1rem;
  color: #64748b;
  margin: 0 0 1rem;
  text-align: center;
}

.school-dashboard {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0 auto;
  padding: 0 0.5rem;
}

.school-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
  width: 100%;
}

@media screen and (max-width: 700px) {
  .school-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.school-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.4rem 1.4rem 1.25rem;
  min-height: 180px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  outline: none;
}

.school-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--card-color, #8919e7);
  transition: height 0.25s ease;
}
.school-card::after {
  content: '';
  position: absolute;
  bottom: -60px;
  right: -60px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: var(--card-color, #8919e7);
  opacity: 0.07;
  transition: transform 0.4s ease, opacity 0.25s ease;
  pointer-events: none;
}

.school-card:hover,
.school-card:focus-visible {
  transform: translateY(-5px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.12);
  border-color: var(--card-color, #8919e7);
}
.school-card:hover::before,
.school-card:focus-visible::before {
  height: 6px;
}
.school-card:hover::after,
.school-card:focus-visible::after {
  transform: scale(1.3);
  opacity: 0.13;
}

.school-card-icon {
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(135deg, var(--card-color, #8919e7), rgba(255, 255, 255, 0.25));
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.14);
  position: relative;
  z-index: 1;
}
.school-card-icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  filter: brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
}

.school-card-body {
  flex: 1 1 auto;
  min-width: 0;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.school-card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.school-card-desc {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.4;
}

.school-card-arrow {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.04);
  color: #94a3b8;
  z-index: 1;
  transition: background 0.25s ease, color 0.25s ease, transform 0.25s ease;
}
.school-card:hover .school-card-arrow,
.school-card:focus-visible .school-card-arrow {
  background: var(--card-color, #8919e7);
  color: #ffffff;
  transform: translateX(2px) translateY(-2px);
}

@media screen and (max-width: 480px) {
  .school-card {
    padding: 1.15rem;
    min-height: 160px;
  }
  .school-card-icon {
    width: 50px;
    height: 50px;
    border-radius: 14px;
  }
  .school-card-icon img {
    width: 26px;
    height: 26px;
  }
  .school-card-title {
    font-size: 1.05rem;
  }
  .school-card-desc {
    font-size: 0.825rem;
  }
}
</style>
